import React from "react";
import { Grid, TextField, withStyles } from "@material-ui/core";
import appConstants from "../../../../../appConstants";

const styles = (theme) => ({
  label: {
    fontSize: theme.textFontSize,
    color: theme.dispatchPanelHeaderColor,
    lineHeight: "16px",
    fontWeight: 600,
    paddingTop: 14,
    paddingBottom: 14,
    letterSpacing: "1.5px",
  },
  valueContainer: {
    display: "flex",
    direction: "column",
    alignItems: "center",
    paddingBottom: 12,
    "&>div": {
      flex: 1,
      width: "100%",
    },
  },
  inputLabelRoot: {
    color: theme.dispatchPanelHeaderColor,
    fontSize: theme.textFontSize,
  },
  inputField: {
    fontSize: theme.textFontSize,
    color: theme.dispatchPanelLabelValueColor,
    height: "initial",
  },
  multilineInput: {
    padding: 12,
  },
  notchedOutline: {
    borderColor: theme.gridIconBorderColor,
  },
  root: {
    marginTop: 0,
    "& $notchedOutline": {
      borderColor: theme.gridIconBorderColor,
    },
    "&:hover $notchedOutline": {
      borderColor: theme.palette.primary.main,
    },
  },
  helperTextRoot: {
    color: theme.gridIconBorderColor,
  },
});

const Notes = (props) => {
  const { classes } = props;
  return (
    <React.Fragment key={props.key}>
      <Grid item xs={12} className={classes.label}>
        COMMENTS
      </Grid>
      <Grid item xs={12} className={classes.valueContainer}>
        <TextField
          id={"comments"}
          autoComplete="off"
          InputLabelProps={{
            classes: {
              root: classes.inputLabelRoot,
            },
          }}
          InputProps={{
            id:"comments",
            classes: {

              input: classes.inputField,
              multiline: classes.multilineInput,
              notchedOutline: classes.notchedOutline,
            },
          }}
          FormHelperTextProps={{
            classes: {
              root: classes.helperTextRoot,
            },
          }}
          inputProps={{
            maxLength: appConstants.ADD_PRO_NOTES.COMMENT_MAX_LENGTH,
          }}
          helperText={`${props.value?.length ?? 0}/${
            appConstants.ADD_PRO_NOTES.COMMENT_MAX_LENGTH
          }`}
          value={props.value}
          multiline
          rowsMax={5}
          rows={4}
          margin="normal"
          onChange={(event) => props.onChange(event.target.value)}
          variant="outlined"
          classes={{ root: classes.root }}
        />
      </Grid>
    </React.Fragment>
  );
};

export default withStyles(styles)(Notes);
